module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/top-level/500-b0eb78d73ee2f88017d90a0d4a67e9ed.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/top-level/500.svg
// module id = 5Fbq
// module chunks = 20 22 23